export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "search-results",
    method: "post",
    body: {
      s: payload
    }
  });

  return await response.json();
};
